import { MemberDto } from '@careapp-group/ng-sdk-v2-new';
import { createReducer, on } from '@ngrx/store';
import { Conversations } from '../actions/index';

export interface ConversationsStateInterface {
  loading: boolean;
  accessToken: string;
  members: MemberDto[];
  error: string;
  initiated: boolean;
  unreadCount: number;
}
export const INITIAL_CONVERSATIONS_STATE: ConversationsStateInterface = {
  loading: false,
  accessToken: null,
  members: [],
  error: '',
  initiated: false,
  unreadCount: 0,
};

export const conversationsReducer = _conversationsReducerFactory(window);

export function _conversationsReducerFactory(_window) {
  return createReducer<ConversationsStateInterface>(
    INITIAL_CONVERSATIONS_STATE,
    on(Conversations.requestConversationsToken, (state, action) => ({
      ...state,
      loading: true,
      accessToken: null,
    })),
    on(Conversations.responseFailConversationsToken, (state, action) => ({
      ...state,
      loading: false,
      accessToken: null,
      error: action.error,
    })),
    on(Conversations.responseSuccessConversationsToken, (state, action) => ({
      ...state,
      loading: false,
      accessToken: action.token,
    })),

    on(Conversations.requestConversationMembers, (state, action) => ({ ...state, loading: true })),
    on(Conversations.responseSuccessConversationMembers, (state, action) => ({
      ...state,
      loading: false,
      members: action.members,
    })),
    on(Conversations.responseFailConversationMembers, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    })),

    on(Conversations.requestInitConversations, (state, action) => ({
      ...state,
      loading: true,
      initiated: false,
    })),
    on(Conversations.responseSuccessInitConversations, (state, action) => ({
      ...state,
      loading: false,
      initiated: true,
    })),
    on(Conversations.responseFailInitConversations, (state, action) => ({
      ...state,
      loading: false,
      initiated: false,
      error: action.error,
    })),

    on(Conversations.requestStartConversation, (state, action) => ({
      ...state,
      loading: true,
    })),
    on(Conversations.responseSuccessStartConversation, (state, action) => ({
      ...state,
      loading: false,
    })),
    on(Conversations.responseFailStartConversation, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    })),

    on(Conversations.requestDisconnectConversations, (state, action) => ({
      ...state,
      loading: true,
    })),
    on(
      Conversations.responseSuccessDisconnectConversations,
      (state, action) => INITIAL_CONVERSATIONS_STATE
    ),
    on(Conversations.responseFailDisconnectConversation, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    })),
    on(Conversations.updateUnreadConversationCount, (state, action) => ({
      ...state,
      unreadCount: action.count,
    })),

    on(Conversations.requestAddChannelModerators, (state, action) => ({
      ...state,
      loading: true,
    })),
    on(Conversations.responseSuccessAddChannelModerators, (state, action) => ({
      ...state,
      loading: false,
    })),
    on(Conversations.responseFailAddChannelModerators, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    })),

    on(Conversations.requestDemoteChannelModerator, (state, action) => ({
      ...state,
      loading: true,
    })),
    on(Conversations.responseSuccessDemoteChannelModerator, (state, action) => ({
      ...state,
      loading: false,
    })),
    on(Conversations.responseFailDemoteChannelModerator, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    }))
  );
}
